export default __webpack_public_path__ + "static/media/The Depression Cycle.1df36665.pdf";